export const SET_USER = "setUser";
export const SAVE_TOKEN = "saveToken";
export const SET_AUTHENTICATED = "setAuthenticated";
